module.exports = __webpack_public_path__ + "img/dikirim-ke-pos.40b4a19d.svg";